:host {
  --overlay-background: rgba(0,0,0,0.6);
  --overlay-z-index: 999;
  --container-bg: #ffffff;

  position: fixed;
  display: flex;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
  background: var(--overlay-background);
  visibility: hidden;
  opacity: 0;
  transition: all .3s ease;
  align-items: center;
  justify-content: center;
}

:host(.overlay-open-true) {
  opacity: 1;
  z-index: var(--overlay-z-index);
  visibility: visible;
}

:host .quark-overlay-mask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: transparent;
  z-index: -1;
}

:host .quark-overlay {
  position: relative;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.jackery-overlay {
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 11px 15px -7px rgba(0, 0, 0, 0.2), 0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12);
  background: var(--container-bg);
}
.container {
  padding: 64px 40px 40px 40px;
  box-sizing: border-box;
  max-width: 90vw;
  max-height: 80vh;
  overflow-y: auto;
  overflow-x: hidden;
}

/* size */
:host(.overlay-size-sm) .container {
  width: 480px;
}

:host(.overlay-size-md) .container {
  width: 660px;
}

:host(.overlay-size-lg) .container {
  width: 880px;
}

@media screen and (max-width: 1024px) {
  .jackery-overlay {
    border-radius: 3.2vw;
  }

  .container {
    padding: 5.3vw;
    max-width: 100vw;
  }

  :host(.overlay-size-sm) .container {
    width: 74.6vw;
  }
  
  :host(.overlay-size-md) .container {
    width: 85.3vw;
  }
  
  :host(.overlay-size-lg) .container {
    width: 100vw;
  }
}
/* size */